import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Tooltip, Input, Button, message, Select } from 'antd'
import {
    MdInfoOutline,
} from "react-icons/md";
import Model from '../Layout/Model';
import PositionFuture from '../Component/PositionFuture';

const { Option } = Select;

const AllBots = () => {

    const [totalPages, setTotalPages] = useState(0);
    const [searchUsernames, setSearchUsernames] = useState('');
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [filter, setFilter] = useState("ALL");
    const [filter1, setFilter1] = useState("FUTURES");
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [statusTPModal, setStatusTPModal] = useState(false)
    const [statusWalletModal, setStatusWalletModal] = useState(false)
    const [recordValue, setRecordValue] = useState("")
    const [recordValueUsername, setRecordValueUsername] = useState("")

    const ViewAPIs = (size, page, tradeType, exchangetype, usernames, status) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            exchange_type: ["FUTURE"],
            api_type: ["LIVE"],
            status: ["ACTIVE"]
        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }


        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
        } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
        }

        if (status && status !== 'ALL') {
            postData.status = [status];
        }


        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/view_bots',
            data: postData
        }).then(res => {
            if (res?.data?.Success === "No transactions yet!") {
                setData([]);
            } else {
                setData(res?.data?.Success);
            }
        }).catch(err => {
            // message.error(err);
        });
    };

    const ViewTotalApis = (size, page, tradeType, exchangetype, usernames, status) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            exchange_type: ["FUTURE"],
            api_type: ["LIVE"],
            status: ["ACTIVE"]
        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }

        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
        } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
        }

        if (status && status !== 'ALL') {
            postData.status = [status];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/total_page_view_bots',
            data: postData
        }).then(res => {
            setTotalPages(res?.data?.Success);
        }).catch(err => {
            console.log(err);
        });
    };
    useEffect(() => {
        ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
        ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
    }, [page, size, filter, filter1, statusFilter]);


    const dataSource = data.map((item) => ({
        Bot_ID: item?.Bot_ID || "--",
        Username: item?.Username || "--",
        APIID: item?.APIID || "--",
        API_Name: item?.API_Name || "--",
        Key: item?.Key || "--",
        Project: item?.Project || "--",
        Secret: item?.Secret || "--",
        Exchange_Type: item?.Exchange_Type || "--",
        Exchange: item?.Exchange || "--",
        Type: item?.Type || "--",
        Reason: item?.Reason || "",
        CopyTradeID: item?.CopyTradeID || "--",
        VarBotID: item?.VarBotID || "--",
        BotName: item?.BotName || "--",
        Symbol: item?.Symbol || "--",
        Investment_Risk: item?.Investment_Risk || "--",
        Status: item?.Status || "--",
        Initial_Balance: item?.Initial_Balance || "--",
        Created_At: item?.Created_At
    }));

    const WalletPasswordUpdate = (value, username) => {
        setRecordValue(value)
        setRecordValueUsername(username)
        setStatusWalletModal(true)
    }
    const TransPasswordUpdate = (value, username) => {
        setRecordValue(value)
        setStatusTPModal(true)
        setRecordValueUsername(username)
    }

    const usernameFormat = recordValueUsername;

    const columns = [
        { title: "Datetime", dataIndex: "Created_At", key: "Created_At", className: "whitespace-nowrap " },
        { title: "Username", dataIndex: "Username", key: "username", className: "whitespace-nowrap " },
        { title: "Exchange", dataIndex: "Exchange", key: "Exchange", className: "whitespace-nowrap " },
        { title: "API Name", dataIndex: "API_Name", key: "API_Name", className: "whitespace-nowrap " },
        { title: "Bot Name", dataIndex: "BotName", key: "BotName", className: "whitespace-nowrap " },
        { title: "Symbol", dataIndex: "Symbol", key: "Symbol", className: "whitespace-nowrap " },
        { title: <Tooltip title="Investment Risk"><div>Invest (R)</div></Tooltip>, dataIndex: "Investment_Risk", key: "Investment_Risk", className: "whitespace-nowrap " },
        {
            title: "Stop Bot", dataIndex: "stop", key: "stop", className: "whitespace-nowrap ",
            render: (text, record) => {
                const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";

                return (
                    <div className="flex items-center gap-3">
                        <button
                            disabled={isDisabled}
                            onClick={() => {
                                WalletPasswordUpdate(record.CopyTradeID, record.Username);
                            }}
                            className={`text-black ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                                }`}
                        >
                            Click
                        </button>
                    </div>
                );
            }
        },
        {
            title: "Delete Bot", dataIndex: "delete", key: "delete", className: "whitespace-nowrap ",
            render: (text, record) => {
                const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";

                return (
                    <div className="flex items-center gap-3">
                        <button
                            disabled={isDisabled}
                            onClick={() => {
                                TransPasswordUpdate(record.CopyTradeID, record.Username);
                            }}
                            className={`text-black ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                                }`}
                        >
                            Click
                        </button>
                    </div>
                );
            }
        },
    ];

    const allColumns = [...columns];

    const handleSearch = () => {
        setPage(1);
        ViewAPIs(size, 1, filter, filter1, searchUsernames, statusFilter);
    };

    const handleStatusCancelWallet = () => {
        setStatusWalletModal(false);
    };

    const handleStatusCancelTP = () => {
        setStatusTPModal(false);
    };

    const handleTPStatus = (values) => {
        const jwt = localStorage.getItem('jwt')
        const postData = {
            jwt: jwt,
            username: recordValueUsername,
            bot_id: recordValue,
            reason: values?.fundComment
        }

        const response = axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + "/bot/delete_bot",
            data: postData
        }).then(response => {
            const responseData = response?.data
            if (responseData?.Success) {
                message.success(responseData?.Success)
                setStatusTPModal(false)
                ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
                ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
            } else {
                message.error(responseData?.Error)
            }
        }).catch(err => {
            message.error(err?.response?.data?.Error)
        })
    }

    const handleWalletStatus = (values) => {
        const jwt = localStorage.getItem('jwt')
        const postData = {
            jwt: jwt,
            username: recordValueUsername,
            bot_id: recordValue,
            reason: values?.fundComment
        }

        const response = axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + "/bot/stop_bot",
            data: postData
        }).then(response => {
            const responseData = response?.data
            if (responseData?.Success) {
                message.success(responseData?.Success)
                setStatusWalletModal(false)
                ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
                ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
            } else {
                message.error(responseData?.Error)
            }
        }).catch(err => {
            message.error(err?.response?.data?.Error)
        })
    }

    const [expandedRowKey, setExpandedRowKey] = useState(null); 

    const handleExpand = (expanded, record) => {
        const newKey = expanded ? record.CopyTradeID : null;
        setExpandedRowKey(newKey);
    };

    return (
        <>
            <div>
                <div className="p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 w-full  mb-4 items-center ">
                        <div className="flex items-center">
                            <Input
                                placeholder="Search username"
                                value={searchUsernames}
                                onChange={(e) => setSearchUsernames(e.target.value.trim().toLowerCase())}
                            />
                            <Button onClick={handleSearch}>
                                Search
                            </Button>
                        </div>
                    </div>

                    <Table
                        dataSource={dataSource}
                        columns={allColumns}
                        pagination={false}
                        expandable={{
                            expandedRowKeys: expandedRowKey ? [expandedRowKey] : [],
                            onExpand: handleExpand,
                            expandedRowRender: (record) => (
                                <PositionFuture
                                    data={{
                                        selectedapi: record.APIID,
                                        apiKey: record.Key,
                                        apiSecret: record.Secret,
                                        type: record.Type,
                                        selectedOptionData: record.Exchange_Type,
                                    }}
                                />
                            ),
                            rowExpandable: (record) => record.CopyTradeID !== null,  // Ensure row is expandable
                        }}
                        scroll={{ x: 1000 }}
                        rowKey="CopyTradeID" 
                    />
                </div>
            </div>

            <Model
                title={<div className='flex justify-between mr-5 items-center'>
                    <p>Stop Bot</p>
                    <Tooltip title={usernameFormat} className='cursor-pointer'>
                        <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
                    </Tooltip>
                </div>}
                open={statusWalletModal}
                onCancel={handleStatusCancelWallet}
                onFinish={handleWalletStatus}
                label1="Reason"
                name1="fundComment"
                placeholder1="Enter Reason"
                isRequired1={true}
            />
            <Model
                title={<div className='flex justify-between mr-5 items-center'>
                    <p>Delete Bot</p>
                    <Tooltip title={usernameFormat} className='cursor-pointer'>
                        <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
                    </Tooltip>
                </div>}
                open={statusTPModal}
                onCancel={handleStatusCancelTP}
                onFinish={handleTPStatus}
                label1="Reason"
                name1="fundComment"
                placeholder1="Enter Reason"
                isRequired1={true}
            />
        </>
    )
}

export default AllBots
